<template>
    <div
        class="ns-tier-card"
        :id="`${baseId}-container`"
        :class="[ 'tc-layout-' + layout, 'tc-type-' + type, 'tc-color-' + color, shadow ? 'tc-shadow' : false, $slots.additional ? 'tc-additional' : false ]"
    >
        <template v-if="isMobile">
            <!-- Mobile -->
            <div class="tc-head tx-font-primary" @click="toggleTier()" :id="`${baseId}-container-mobile`">
                <div class="tc-head-background" :id="`${baseId}-container-mobile-head-background`"></div>
                <div v-if="type == 'vip'" class="tc-head-promotion" :id="`${baseId}-container-mobile-head-vip`">
                    <h2
                        class="tc-head-title tx-font-primary text-uppercase"
                        v-html="$nsLanguage.getTranslation(configuration.context + '.vipTitle')"
                        :id="`${baseId}-container-mobile-head-title`"
                    >
                    </h2>
                    <p class="tc-head-text" v-html="$nsLanguage.getTranslation(configuration.context + '.vipSummary')" :id="`${baseId}-container-mobile-head-text`"></p>
                </div>
                <div v-else class="tc-head-details" :id="`${baseId}-container-mobile-non-vip`">
                    <div class="tc-head-icon" :id="`${baseId}-container-mobile-non-vip-head-icon-container`">
                        <img v-if="icon == 'bag'" src="@/assets/tiering-bag-icon.svg" :id="`${baseId}-container-mobile-non-vip-head-icon-bag`" />
                        <img v-else-if="icon == 'star'" src="@/assets/tiering-star-icon.svg" :id="`${baseId}-container-mobile-non-vip-head-icon-star`" />
                    </div>
                    <div class="tc-head-stack" :id="`${baseId}-container-mobile-non-vip-head-stack`">
                        <h2 class="tc-head-title tx-font-primary text-uppercase" :id="`${baseId}-container-mobile-non-vip-tier-title`">
                            {{ $nsLanguage.getTranslation(configuration.context + '.' + content.tierId) }}
                        </h2>
                        <div class="tc-head-text text-capitalize" :id="`${baseId}-container-mobile-non-vip-non-vip-cashback-text-container`">
                            <span
                                v-html="$nsLanguage.getTranslation(configuration.context + '.cashBack', { purchaseRatio: $options.filters.numeral(content.purchaseRatio, '0%') })"
                                :id="`${baseId}-container-mobile-non-vip-non-vip-cashback-text`"
                            >
                            </span>
                        </div>
                    </div>
                    <button v-if="togglable" class="tc-button text-uppercase" :id="`${baseId}-container-mobile-non-vip-non-vip-cashback-show-hide-rewards-button`">
                        <span v-if="tierOpen" :id="`${baseId}-container-mobile-non-vip-non-vip-cashback-hide-rewards-button-text`">
                            {{ $nsLanguage.getTranslation(configuration.context + '.hideRewardsButton') }}
                        </span>
                        <span v-else :id="`${baseId}-container-mobile-non-vip-non-vip-cashback-show-rewards-button-text`">
                            {{ $nsLanguage.getTranslation(configuration.context + '.viewRewardsButton') }}
                        </span>
                    </button>
                </div>
            </div>
            <v-expansion-panels
                v-if="type != 'vip'"
                class="tc-body"
                :readonly="!togglable"
                :value="tierOpen ? 0 : -1"
                :id="`${baseId}-container-mobile-expansion-panels`"
            >
                <v-expansion-panel class="tc-body-ep" :id="`${baseId}-container-mobile-expansion-panel`">
                    <v-expansion-panel-header class="d-none" :id="`${baseId}-container-mobile-expansion-panel-header`"></v-expansion-panel-header>
                    <v-expansion-panel-content class="tc-body-content" :id="`${baseId}-container-mobile-expansion-panel-content`">
                        <ul class="tc-section tc-bullet-list" :id="`${baseId}-container-mobile-expansion-panel-content-bullet-list`">
                            <li
                                v-for="(bullet, ji) in content.bullets"
                                :key="ji" class="checkmark"
                                :id="`${baseId}-container-mobile-expansion-panel-content-bullet-list-bullet-${ji}`"
                            >
                                <v-card-text class="ma-0 pa-0" :id="`${baseId}-container-mobile-expansion-panel-content-bullet-list-bullet-${ji}-card`">
                                    <span
                                        class="text tx-em-bold-800 tx-gray-dark"
                                        v-html="bullet"
                                        :id="`${baseId}-container-mobile-expansion-panel-content-bullet-list-bullet-${ji}-card-text`"
                                    >
                                    </span>
                                </v-card-text>
                            </li>
                        </ul>
                        <div v-if="$slots.additional" class="tc-section" :id="`${baseId}-container-mobile-expansion-panel-content-additional-content`">
                            <slot name="additional"></slot>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <div v-else-if="type == 'vip' && $slots.additional" class="tc-body-content" :id="`${baseId}-container-mobile-vip-additional-content-container`">
                <div class="tc-section" :id="`${baseId}-container-mobile-vip-additional-content-section`">
                    <slot name="additional"></slot>
                </div>
            </div>
        </template>
        <template v-else>
            <!-- Tablet/Desktop -->
            <div class="tc-head tx-font-primary" :id="`${baseId}-container-non-mobile`">
                <div class="tc-head-background" :id="`${baseId}-container-non-mobile-head-background`"></div>
                <div v-if="type == 'vip'" class="tc-head-promotion" :id="`${baseId}-container-non-mobile-head-vip`">
                    <h2
                        class="tc-head-title tx-font-primary text-uppercase"
                        v-html="$nsLanguage.getTranslation(configuration.context + '.vipTitle')"
                        :id="`${baseId}-container-non-mobile-head-title`"
                    >
                    </h2>
                    <p class="tc-head-text" v-html="$nsLanguage.getTranslation(configuration.context + '.vipSummary')" :id="`${baseId}-container-non-mobile-head-text`"></p>
                </div>
                <div v-else class="tc-head-details" :id="`${baseId}-container-non-mobile-non-vip`">
                    <div class="tc-head-icon" :id="`${baseId}-container-non-mobile-non-vip-head-icon-container`">
                        <img v-if="icon == 'bag'" src="@/assets/tiering-bag-icon.svg" :id="`${baseId}-container-non-mobile-non-vip-head-icon-bag`"/>
                        <img v-else-if="icon == 'star'" src="@/assets/tiering-star-icon.svg" :id="`${baseId}-container-non-mobile-non-vip-head-icon-star`"/>
                    </div>
                    <h2 class="tc-head-title tx-font-primary text-uppercase" :id="`${baseId}-container-non-mobile-non-vip-tier-title`">
                        {{ $nsLanguage.getTranslation(configuration.context + '.' + content.tierId) }}
                    </h2>
                    <div class="tc-head-text tc-head-text-normal" :id="`${baseId}-container-non-mobile-non-vip-non-vip-cashback-text-container`">
                        <span
                            class="tc-head-subtext"
                            v-html="$nsLanguage.getTranslation(configuration.context + '.cashBack', { purchaseRatio: $options.filters.numeral(content.purchaseRatio, '0%') })"
                            :id="`${baseId}-container-non-mobile-non-vip-non-vip-cashback-text`"
                        >
                        </span>
                    </div>
                </div>
            </div>
            <v-expansion-panels
                v-if="type != 'vip'"
                class="tc-body"
                :readonly="!togglable"
                :value="tierOpen ? 0 : -1"
                :id="`${baseId}-container-non-mobile-expansion-panels`"
            >
                <v-expansion-panel class="tc-body-ep" :id="`${baseId}-container-non-mobile-expansion-panel`">
                    <v-expansion-panel-header class="text-capitalize tc-body-head" :class="{ 'd-none': !togglable }" :id="`${baseId}-container-non-mobile-expansion-panel-header`">
                        {{ $nsLanguage.getTranslation(configuration.context + '.tierDetailsHeading') }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="tc-body-content" :id="`${baseId}-container-non-mobile-expansion-panel-content`">
                        <ul class="tc-section tc-bullet-list" :id="`${baseId}-container-non-mobile-expansion-panel-content-bullet-list`">
                            <li
                                v-for="(bullet, ji) in content.bullets"
                                :key="ji"
                                class="checkmark"
                                :id="`${baseId}-container-non-mobile-expansion-panel-content-bullet-list-bullet-${ji}`"
                            >
                                <v-card-text class="ma-0 pa-0" :id="`${baseId}-container-non-mobile-expansion-panel-content-bullet-list-bullet-${ji}-card`">
                                    <span
                                        class="text tx-em-bold-800 tx-gray-dark"
                                        v-html="bullet"
                                        :id="`${baseId}-container-non-mobile-expansion-panel-content-bullet-list-bullet-${ji}-card-text`"
                                    >
                                    </span>
                                </v-card-text>
                            </li>
                        </ul>
                        <div v-if="$slots.additional" class="tc-section" :id="`${baseId}-container-non-mobile-expansion-panel-content-additional-content`">
                            <slot name="additional"></slot>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <div v-else-if="type == 'vip' && $slots.additional" class="tc-body-content" :id="`${baseId}-container-non-mobile-vip-additional-content-container`">
                <div class="tc-section">
                    <slot name="additional"></slot>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    name: 'ns-tier-card',
    props: {
        color: {
            type: String,
            default: 'gray',
            validator (value) {
                return ['gray', 'blue', 'green', 'red'].indexOf(value) >= 0
            }
        },
        icon: {
            type: String,
            default: 'none',
            validator (value) {
                return ['none', 'bag', 'star'].indexOf(value) >= 0
            }
        },
        layout: {
            type: String,
            default: 'mobile',
            validator (value) {
                return ['mobile', 'tablet', 'desktop'].indexOf(value) >= 0
            }
        },
        parentId: {
            type: String,
            required: false
        },
        shadow: {
            type: Boolean,
            default: false
        },
        togglable: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'common',
            validator (value) {
                return ['common', 'vip'].indexOf(value) >= 0
            }
        },
        configuration: {
            type: Object,
            default: function () {
                return {}
            }
        },
        content: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        baseId: function () {
            const defaultBase = 'tier-card'
            if (this.parentId) {
                return `${this.parentId}-${defaultBase}`
            } else {
                return defaultBase
            }
        },
        isMobile () {
            return this.layout === 'mobile'
        },
        isTablet () {
            return this.layout === 'tablet'
        },
        tierOpen () {
            return this.togglable ? this.open : true
        }
    },
    data () {
        return {
            open: this.togglable ? !!this.configuration.open : true
        }
    },
    methods: {
        toggleTier () {
            if (this.togglable) {
                this.open = !this.open
            }
        }
    }
}

</script>

<style lang="scss" scoped>

@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/buttons";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

$color-black: #000000;
$color-blue: #02B2DF;
$color-green: #40BDA5;
$color-gray: #585858;
$color-red: #BE0077;
$color-white: #FFFFFF;

.tx-em-bold-800 {
    ::v-deep {
        b, em, i {
            font-family: inherit;
            font-style: normal;
            font-weight: 800;
        }
    }
}

.ns-tier-card {
    $tc-large-head-width: 215px;
    $tc-large-head-font-size: 20px;
    $tc-small-head-width: 100%;
    $tc-small-head-font-size: 12px;
    $tc-small-body-font-size: 14px;

    display: inline-block;
    position: relative;
    width: 100%;

    .tc-head {
        overflow: hidden;
        position: relative;
        width: 100%;
        border-radius: 0;
        color: $color-white;
        font-weight: 600;

        .tc-button {
            padding: 7px 22px;
            background: $color-white;
            border-radius: 4px;
            outline: 0 none;
            color: rgba($color-black, 0.85);
            font-size: 12px;
            font-weight: 600;
            text-align: center;
            line-height: 1.4166em;
        }
    }

    .tc-head-background {
        z-index: 10;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .tc-head-details {
        position: relative;
        z-index: 20;
        display: flex;
        flex-direction: column;
    }

    .tc-head-icon {
        img {
            width: 100%;
        }
    }

    .tc-head-title,
    .tc-head-text {
        color: $color-white;
    }

    .tc-head-title {
        font-weight: 600;
        line-height: 1.3333em;
    }

    .tc-body {
        font-size: $tc-small-body-font-size;

        // Override Vuetify css.
        border-radius: 0 !important;

        .v-expansion-panel::before {
            box-shadow: none;
        }
        // End of Vuetify overrides.
    }

    .tc-body-ep {
        border-radius: 0;
        box-shadow: none;
    }

    .tc-body-content {
        background-color: $color-white;
        padding: 0 15px;

        &::v-deep .v-expansion-panel-content__wrap {
            padding: 0;
        }
    }

    .tc-bullet-list {
        $tc-checkmark-size: 20px;

        &,
        & li {
            list-style-type: none;
            list-style-image: none;
            list-style-position: inside;
            margin: 0;
            padding: 0;
        }

        li {
            display: flex;
            align-content: center;
            align-items: center;
            position: relative;
            margin-top: 0;

            ::v-deep em {
                font-style: normal;
                font-weight: 700;
            }

            .text {
                font-weight: normal;
                line-height: 1.11;
            }

            & + li {
                margin-top: 15px;
            }
        }

        li.checkmark {
            min-height: $tc-checkmark-size;
            padding-left: $tc-checkmark-size + 10px;

            &::before {
                display: inline-block;
                position: absolute;
                top: 0;
                left: 0;
                width: $tc-checkmark-size;
                height: $tc-checkmark-size;
                background-image: url( '~@/assets/icons/Icon_Checkmark_Inactive.svg' );
                background-attachment: local;
                background-origin: padding-box;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: contain;
                content: ' ';
            }
        }
    }

    .tc-head-promotion {
        $font-size-small: 12px;
        $font-size-large: 18px;

        position: relative;
        z-index: 20;

        .tc-head-title {
            font-size: $font-size-small;
            font-weight: 600;
            line-height: 1.3333em;
            text-align: center;
            text-transform: uppercase;

            ::v-deep small {
                font-size: inherit;
            }
        }

        .tc-head-text {
            margin: 8px 0 0 0;
            font-size: $font-size-large;
            font-weight: 600;
            line-height: 1.3333em;
            text-align: center;

            ::v-deep small {
                font-size: inherit;
            }
        }
    }

    &.tc-layout-tablet,
    &.tc-layout-desktop {
        .tc-head-promotion {
            $font-size-small: 14px;
            $font-size-large: 20px;
            $font-size-reduce: 0.86;

            .tc-head-title {
                font-size: $font-size-small;

                ::v-deep small {
                    font-size: $font-size-small * $font-size-reduce;
                }
            }

            .tc-head-text {
                margin: 8px 0 0 0;
                font-size: $font-size-large;

                ::v-deep small {
                    font-size: $font-size-large * $font-size-reduce;
                }
            }
        }
    }

    &.tc-color-blue {
        .tc-bullet-list li.checkmark::before {
            background-image: url( '~@/assets/icons/Icon_Checkmark_Blue.svg' );
        }
    }

    &.tc-color-green {
        .tc-bullet-list li.checkmark::before {
            background-image: url( '~@/assets/icons/Icon_Checkmark_Green.svg' );
        }
    }

    &.tc-color-red {
        .tc-bullet-list li.checkmark::before {
            background-image: url( '~@/assets/icons/Icon_Checkmark_Red.svg' );
        }
    }

    .tc-section {
        padding: 15px 0;
        border-top: 0 none;

        & + .tc-section {
            border-top: 1px solid #CED0D0;
        }
    }

    //------------------------------------------------------------------------------------------------

    &.tc-shadow {
        box-shadow: 0 2px 17px 3px rgba(132, 129, 129, 0.25);
    }

    //------------------------------------------------------------------------------------------------

    &.tc-layout-mobile {
        width: $tc-small-head-width;
        margin-top: 10px;

        .tc-button {
            flex-grow: 0;
            flex-shrink: 0;
            width: 142px;
        }

        .tc-head {
            padding: 14px 15px;
            font-size: $tc-small-head-font-size;
        }

        .tc-head-icon,
        .tc-head-stack,
        .tc-head-title,
        .tc-head-text,
        .tc-button {
            position: relative;
            z-index: 20;
        }

        .tc-head-icon {
            flex-grow: 0;
            flex-shrink: 0;
            width: 43px;
            margin-right: 10px;
        }

        .tc-head-title {
            font-size: $tc-small-head-font-size;
            line-height: 1.3333em;
        }

        .tc-head-details {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: center;
            align-items: center;
            flex-basis: 100%;
        }

        .tc-head-stack {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            width: 100%;
            margin-right: 10px;
            text-align: left;
        }

        .tc-head-text {
            margin-top: 5px;
            font-size: $tc-small-head-font-size * 1.8333;
            line-height: 0.75em;

            &::v-deep small {
                font-size: $tc-small-head-font-size;
            }
        }
    }

    &.tc-layout-tablet,
    &.tc-layout-desktop {
        width: $tc-large-head-width;

        .tc-head {
            height: 123px;
            padding: 10px 15px 5px 15px;
            font-size: $tc-large-head-font-size;
        }

        .tc-head-icon {
            display: none;
        }

        .tc-head-title {
            font-size: $tc-large-head-font-size;
            line-height: 1.3333em;
            text-align: center;
        }

        .tc-head-text {
            font-size: $tc-large-head-font-size * 2.25;
            line-height: 1em;
            text-align: center;

            &::v-deep small {
                font-size: $tc-large-head-font-size;
                font-weight: 400;
                line-height: normal;
                margin: 5px 0 0 0;
            }
        }

        .tc-head-subtext {
            display: flex;
            flex-direction: column;
            margin: 5px 0 0 0;
        }

        .tc-body-head {
            min-height: auto;
            padding: 8px 15px;
            border-radius: 0;
            border: 0 none;
            border-bottom: 1px solid #ECEDED;
            color: #63666A;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.50em;
        }

        .tc-body-content {
            padding: 5px 15px;
        }
    }

    //------------------------------------------------------------------------------------------------

    &.tc-color-blue {
        .tc-head {
            background: $color-blue;
            background-image: linear-gradient(-135deg, rgb(5, 217, 241) 0%, rgb(2, 178, 223) 100%);
        }

        .tc-head-background {
            opacity: 0.23;
            background-image: url('~@/assets/tiering-bag-icon.svg');
            background-position-x: 98%;
            background-position-y: -98%;
            background-size: 53%;
        }
    }

    &.tc-color-green {
        .tc-head {
            background: $color-green;
            background-image: linear-gradient(to top right, $color-green 0%, #C2D42E 100%);
        }

        .tc-head-background {
            opacity: 0.50;
            background-image: url('~@/assets/Stripe_LargeDashes_Green.svg');
        }
    }

    &.tc-color-gray {
        .tc-head {
            background: $color-gray;
            background-image: linear-gradient(to top right, $color-gray 0%, #b7b7b7 100%);
        }

        .tc-head-background {
            opacity: 0.15;
            background-image: url('~@/assets/tiering-star-icon.svg');
            background-position-x: 98%;
            background-position-y: -98%;
            background-size: 53%;
        }
    }

    &.tc-color-red {
        .tc-head {
            background: $color-red;
        }

        .tc-head-background {
            opacity: 1;
            background-image: url('~@/assets/Lips_Muah.png');
            background-position: center right;
            background-size: auto 100%;
        }
    }
}

</style>
